import { Component } from '@angular/core';
import { ApiService, FacebookService, JSONHash, RegistrationStep } from 'angular-lib';
import { FileItem, FileLikeObject, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../../services/loader.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ez-photo',
    template: require('./photo.component.html'),
    styles: [require('./photo.component.less')],
})
export class PhotoComponent extends RegistrationStep {
    public uploader: FileUploader;
    public errorString: string;
    public uploading: boolean = false;
    public facebookPictures: JSONHash[];

    constructor(
        private apiService: ApiService,
        private facebookService: FacebookService,
        private loaderService: LoaderService,
        private translationService: TranslateService,
        private loader: LoaderService,
    ) {
        super();
        this.uploader = new FileUploader({
            url: this.apiService.uploadPictureUrl(),
            autoUpload: true,
            isHTML5: true,
            headers: [
                {name: 'Accept', value: 'application/json'}
            ],
            maxFileSize: 12582912 // 12Mo max file size
        });
        this.uploader.authToken = 'Bearer ' + localStorage.getItem(environment.tokenName);
        this.uploader.onAfterAddingFile = (file: FileItem) => {
            file.withCredentials = false;
            file.alias = 'uploadPicture';
            file.onBeforeUpload = () => {
                this.uploading = true;
                this.loaderService.show();
            };
            file.onProgress = (p) => {
                console.log('onProgress', p);
            };
            file.onComplete = () => {
                this.uploading = false;
            };
            file.onSuccess = (response: string) => {
                try {
                    let json = JSON.parse(response);
                    if (json.result.error) {
                        throw new Error(json.result.error.message);
                    }
                    this.submit();
                } catch (e) {
                    this.errorString = (e as Error).message;
                }
            };
            file.onError = (response: string, status: number, headers: ParsedResponseHeaders) => {
                this.errorString = 'erreur';
            };
            file.onComplete = () => {
                this.loaderService.hide();
            }
        };
        this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
            if (filter.name === 'fileSize') {
                this.translationService.get('common.errors.photo-too-large').subscribe(res => {
                    this.errorString = res;
                })
            }
        }
    }

    public fbSignedIn(accessToken) {
        this.loader.show();
        this.apiService.get('/f/facebook/profilePictures?accessToken=' + accessToken)
            .subscribe(
                (data: Array<any>) => {
                    console.log(data);
                    // pre select first 8
                    data.slice(0, 8).forEach(i => i.selected = true);
                    this.facebookPictures = data;
                    this.loader.hide();
                },
                error => {
                    this.loader.hide();
                },
            );
    }

    public fbUpload() {
        let urls = this.facebookPictures.filter(e => e.selected).map(e => e.source) as string[];
        this.apiService.uploadPictures(urls).subscribe((res) => {
            this.submit();
        });
    }

    public triggerBackButton() {
        if (this.facebookPictures) {
            // cancel facebook pictures upload
            this.facebookPictures = null;
        } else {
            // classic back (previous step)
            this.back();
        }
    }

    public triggerNextButton() {
        if (this.facebookPictures) {
            // upload facebook pictures
            this.fbUpload();
        } else {
            // classic next (next step)
            this.submit();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/photo/photo.component.ts